<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 12a2 2 0 0 1 1-1.734V7H9v3.267a2 2 0 1 1-2 .001V7H3v3.269a2 2 0 1 1-2-.001V4h14v6.267A2 2 0 1 1 12 12Z" transform="translate(0 1)" fill="currentColor"/><path d="M1 1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3H1V1Z" opacity=".45" transform="translate(0 1)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering160',
});
</script>
